import { IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { MuiShadowIconToggleOverrideGenerator } from 'theme/overrides/MuiShadowIconToggleOverride';
export var FiltersVisibilityButtonOn = withStyles(MuiShadowIconToggleOverrideGenerator(true))(IconButton);
export var FiltersVisibilityButtonOff = withStyles(MuiShadowIconToggleOverrideGenerator(false))(IconButton);